import React, { useState } from 'react'
import { Provider } from 'react-redux'
import store from './store'

import Amplify from 'aws-amplify';
import aws_exports from './config/aws-exports';

import './styles/styles.scss';
import "@aws-amplify/ui-react/styles.css";

import Header from './components/Header.js';
import RouteSwitch from './components/RouteSwitch.js';

Amplify.configure(aws_exports);

function App() {
  const [modal, setModal] = useState({ show: false, initialState: 'signIn' });

  const openModal = (initialState = 'signIn') => setModal({ show: true, initialState });
  const closeModal = () => setModal(m => ({ ...m, show: false }));

  return (
    <div className="App">
      <Provider store={store}>
        <Header
          modalShow={modal.show}
          modalInitialState={modal.initialState}
          onModalHide={closeModal}
          onSignIn={() => openModal('signIn')}
        />
        <RouteSwitch onGetStarted={() => openModal('signUp')} />
      </Provider>
    </div>
  );
}

export default App;
